/* Product-card mini-carousel
   Baymard: meerdere thumbnails in de productlijst, swipe op mobiel,
   pijlen + dots op desktop. Event-delegated, geen dependencies. */
(function () {
  'use strict';

  function getSlides(track) {
    return track ? Array.prototype.slice.call(track.querySelectorAll('.pc-slide')) : [];
  }

  function slideWidth(track) {
    var s = getSlides(track);
    return (s[0] && s[0].offsetWidth) || track.clientWidth || 1;
  }

  function currentIndex(track) {
    return Math.round(track.scrollLeft / slideWidth(track));
  }

  function scrollToIndex(track, idx) {
    var s = getSlides(track);
    if (!s.length) return;
    idx = Math.max(0, Math.min(idx, s.length - 1));
    /* scrollIntoView werkt betrouwbaar samen met scroll-snap (anders dan
       track.scrollTo/scrollLeft, die door snap-mandatory teruggezet worden) */
    s[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function setActiveDot(carousel, idx) {
    var dots = carousel.querySelectorAll('[data-pc-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('pc-dot-active', parseInt(dots[i].getAttribute('data-pc-dot'), 10) === idx);
    }
  }

  /* One delegated click handler for every card on the page (current + future).
     preventDefault + stopPropagation so controls inside the card <a> never navigate. */
  document.addEventListener('click', function (e) {
    var ctrl = e.target.closest('[data-pc-prev],[data-pc-next],[data-pc-dot]');
    if (!ctrl) return;
    var carousel = ctrl.closest('[data-pc-carousel]');
    if (!carousel) return;
    e.preventDefault();
    e.stopPropagation();
    var track = carousel.querySelector('[data-pc-track]');
    if (!track) return;
    if (ctrl.hasAttribute('data-pc-dot')) {
      scrollToIndex(track, parseInt(ctrl.getAttribute('data-pc-dot'), 10));
    } else {
      scrollToIndex(track, currentIndex(track) + (ctrl.hasAttribute('data-pc-next') ? 1 : -1));
    }
  });

  function bindTrack(track) {
    if (track.dataset.pcBound) return;
    track.dataset.pcBound = '1';
    var carousel = track.closest('[data-pc-carousel]');
    if (!carousel) return;
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        setActiveDot(carousel, currentIndex(track));
      });
    }, { passive: true });
  }

  function init() {
    var tracks = document.querySelectorAll('[data-pc-track]');
    for (var i = 0; i < tracks.length; i++) bindTrack(tracks[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  /* ── Quick-add naar de cart drawer (13-08-2026) ─────────────────────────
     Het plusje op de productkaart was een KAAL html-form met action=/cart/add
     en method=post. Zonder JS doet de browser daar een echte form-POST op, en
     Shopify antwoordt met een redirect naar /cart. De klant werd dus uit de
     collectie geschopt naar de winkelwagenpagina, precies op het moment dat hij
     verder wilde winkelen. Live gereproduceerd op 13-08 (mobiel 390px,
     /collections/koivoer-basis): na een klik op het plusje stond de browser op
     https://vijvercentrum.nl/cart.
     Alle andere add-to-cart-paden in dit theme (PDP, Doofinder, predictive
     search, VijverCheck, collection-popup) doen al een fetch naar /cart/add.js
     gevolgd door cart:refresh en CartDrawer.open(). Deze handler trekt de
     productkaart in datzelfde patroon.
     BIJVANGST: snippets/ga4-ecommerce.liquid onderschept fetch-calls naar
     /cart/add met method POST en stuurt daar add_to_cart op. De quick-add
     deed een form-POST en werd daarom NOOIT als add_to_cart geteld; vanaf nu
     wel.
     VANGNET: elke fout, elk ontbrekend onderdeel en elke afwezige drawer valt
     terug op de gewone form-submit. De knop mag nooit dood zijn: liever de
     oude route naar /cart dan een plusje waar niets van komt. */
  function quickAddFallback(form) {
    try { HTMLFormElement.prototype.submit.call(form); } catch (err) { /* niets meer te doen */ }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[data-pc-quick-add]')) return;

    /* Geen drawer of geen fetch: laat de native submit gewoon doorgaan. */
    if (!window.CartDrawer || typeof window.fetch !== 'function') return;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput && parseInt(idInput.value, 10);
    if (!id) return; /* niets te versturen, native pad houdt het gedrag gelijk */

    e.preventDefault();

    /* Dubbele verzending tegenhouden zonder de knop zichtbaar dood te maken. */
    if (form.dataset.pcBusy === '1') return;
    form.dataset.pcBusy = '1';
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('opacity-60');

    var klaar = function () {
      form.dataset.pcBusy = '';
      if (btn) btn.classList.remove('opacity-60');
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/add gaf ' + res.status);
      return res.json();
    }).then(function (data) {
      klaar();
      var live = document.getElementById('AjaxLiveRegion');
      if (live) live.textContent = ((data && data.title) || 'Product') + ' toegevoegd aan winkelwagen';
      if (btn) {
        btn.classList.add('bg-green-500');
        setTimeout(function () { btn.classList.remove('bg-green-500'); }, 1500);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.CartDrawer) window.CartDrawer.open();
    }).catch(function (err) {
      /* Niet stranden: alsnog het oude pad, dan komt de klant hoe dan ook
         bij zijn product. */
      if (window.console && console.warn) console.warn('quick-add viel terug op form-submit:', err);
      klaar();
      quickAddFallback(form);
    });
  }, false);

})();
